// @flow

import { observer } from "mobx-react";
import React from "react";

import Icon from "app/components/Icon/Icon";

import "./AuthButton.scss";

type Props = {
    text?: string,
    name: string,
    icon?: string,
    onClick?: Function,
    image?: boolean
};

@observer
export default class AuthButton extends React.Component<Props> {
    renderIcon() {
        const icon = this.props.icon || this.props.name;
        if (this.props.image) {
            return (
                <img
                    src={`/resources/assets/images/auth/${icon}_15x15.png`}
                    alt={this.props.name}
                    className="AuthButton__image"
                />
            );
        }

        return <Icon name={icon} fontAwesome={true} />;
    }

    render() {
        const name = this.props.name;
        const url = this.props.onClick ? "javascript;" : "/auth/" + name;
        const ucFirstName =
            name.substring(0, 1).toUpperCase() + name.substring(1);

        const text = this.props.text || `Sign up with ${ucFirstName}`;

        const classes = ["AuthButton", "AuthButton--" + name];
        return (
            <a
                href={url}
                className={classes.join(" ")}
                onClick={this.props.onClick}
            >
                {this.renderIcon()} {text}
            </a>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/AuthButton/AuthButton.js